import React from "react";
import { useAppContext } from "../../../../../lib/appContext";
import { Pagination } from "../../Pagination";
import { ResultList } from "../ResultList";
import { useProductsContext } from "../state/products";
import { EmptyResultList } from "./EmptyResultList";
import { getTotalPages } from "./helpers";
import { useProductsProps } from "./useProductsProps";

const ProductList: React.FC = () => {
  const getProductsProps = useProductsProps();
  const { products, totalResults, loading, page } = useProductsContext();
  const items = !loading && products ? products.map(getProductsProps) : [];
  const { businessUnitConfig, businessUnitSlug } = useAppContext();
  return (
    <div id={businessUnitConfig.businessCode} data-id={businessUnitSlug}>
      {loading || items.length > 0 ? (
        <>
          <ResultList items={items} isLoading={loading} />
          {!loading && <Pagination totalPages={getTotalPages(totalResults)} page={page} />}
        </>
      ) : (
        <EmptyResultList />
      )}
    </div>
  );
};

export { ProductList, ProductList as default };
